import _ from 'lodash';
import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

const defaultFilters = {
  channels: [],
  collections: [],
  speakers: [],
  tags: [],
  years: [],
  query: null,
  displayQuery: false,
};

const getters = {
  [getterTypes.GET_SERVICES]: state => state.services,
  [getterTypes.GET_SERVICES_AGGREGATIONS]: state => state.aggs,
  [getterTypes.GET_SERVICES_FILTERS]: state => state.filters,
  [getterTypes.GET_SERVICES_MODE]: state => state.mode,
  [getterTypes.GET_SERVICES_NEXT_PAGE]: state => state.next,
  [getterTypes.GET_SERVICES_REFRESH]: state => state.refresh,
};

const actions = {
  async [actionTypes.DO_GET_SERVICES]({ commit }, params) {
    const { data } = await HTTP.get('/services', { params });
    commit(mutationTypes.SET_SERVICES, data.data.services);
    return data;
  },
};

const mutations = {
  [mutationTypes.SET_SERVICES](state, services) {
    state.services = services;
  },
  [mutationTypes.SET_SERVICES_FILTER](state, payload) {
    Vue.set(state.filters, payload.key, payload.val);
  },
  [mutationTypes.SET_SERVICES_FILTER_DEFAULTS](state) {
    state.filters = _.cloneDeep(defaultFilters);
  },
  [mutationTypes.SET_SERVICES_MODE](state, mode) {
    state.mode = mode;
  },
  [mutationTypes.SET_SERVICES_NEXT_PAGE](state, next) {
    state.next = next;
  },
  [mutationTypes.SET_SERVICES_REFRESH](state, refresh) {
    state.refresh = refresh;
  },
  [mutationTypes.TOGGLE_SERVICES_FILTER](state, payload) {
    const filters = state.filters[payload.key];
    const index = _.findIndex(filters, { id: payload.val.id });
    if (index < 0) {
      state.filters[payload.key].push(payload.val);
    } else {
      state.filters[payload.key].splice(index, 1);
    }
  },
};

export default {
  state: {
    aggs: {
      channels: {
        nested: {
          path: '_embedded.channels',
        },
        aggs: {
          nested_channels: {
            terms: {
              field: '_embedded.channels.title.raw',
            },
            aggs: {
              channel: {
                top_hits: {
                  size: 1,
                },
              },
            },
          },
        },
      },
      speakers: {
        terms: {
          field: '_embedded.speaker.full_name.raw',
          size: 12,
        },
        aggs: {
          episode: {
            top_hits: {
              size: 1,
              _source: {
                includes: ['_embedded.speaker'],
              },
            },
          },
        },
      },
      tags: {
        terms: {
          field: 'tags',
        },
      },
      years: {
        date_histogram: {
          field: 'pub_date',
          interval: 'year',
          format: 'yyyy',
          order: { _key: 'desc' },
        },
      },
    },
    filters: _.cloneDeep(defaultFilters),
    mode: 'sermons',
    next: false,
    refresh: false,
    services: [],
  },
  getters,
  actions,
  mutations,
};
